// extracted by mini-css-extract-plugin
export var disabledStyle = "video_play_button-module--disabledStyle--LRYn2";
export var isVisibleStyle = "video_play_button-module--isVisibleStyle--YZxV9";
export var playButtonStyle = "video_play_button-module--playButtonStyle--Z+JDI";